import axios from "axios";
import Swal from "sweetalert2";
import {
  baseUrl,
  defaultAddErrorMessage,
  defaultUpdateErrorMessage,
  errorTranslate,
  objectifyForDropdown,
} from "../util";

export const addWasteToBusiness = ({
  businessId,
  type_surplus_material,
  type_current_disposal,
  is_reused,
  category,
  subcategory,
  subcategory_description,
  amount,
  price_invoice,
  current_disposal,
  product,
  avoided_emission,
  buyer,
  share,
  surplus_materials_sold,
  invoice_date,
  invoice_number,
  type_waste_water,
  total_waste_water,
  water_sold,
  type_surplus_energy,
  typedb_surplus_energy,
  wasted_surplus_energy,
  sold_surplus_energy,
  wasted_energy,
  money_earned,
  wasted_emission,
  nickname,
  loading = null,
  setLoading = null,
  index,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
  triggerInvalidate = function () {
    return;
  },
}) => {
  const key = "add-new-waste";
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  var data = JSON.stringify({
    type_surplus_material: type_surplus_material,
    type_current_disposal: type_current_disposal,
    is_reused: is_reused,
    category: category,
    subcategory: subcategory,
    subcategory_description: subcategory_description,
    amount: amount,
    price_invoice: price_invoice || null,
    current_disposal: current_disposal || 0,
    avoided_emission: avoided_emission || null,
    product: product,
    surplus_materials_sold: surplus_materials_sold || null,
    buyer: buyer || null,
    share: share || null,
    invoice_date: invoice_date || null,
    invoice_number: invoice_number || null,
    type_waste_water: type_waste_water,
    total_waste_water: total_waste_water,
    water_sold: water_sold || null,
    type_surplus_energy: type_surplus_energy,
    typedb_surplus_energy: typedb_surplus_energy,
    wasted_surplus_energy: wasted_surplus_energy,
    sold_surplus_energy: sold_surplus_energy || null,
    wasted_energy: wasted_energy || null,
    money_earned: money_earned,
    wasted_emission: wasted_emission,
    nickname: nickname,
    year: year,
  });

  var config = {
    method: "post",
    url: baseUrl + "/api/business/" + businessId + "/waste",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (key) {
        triggerInvalidate(key);
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
    });
};

export const deleteWaste = ({
  businessId,
  objectId,
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
}) => {
  var config = {
    method: "delete",
    url: baseUrl + "/api/business/" + businessId + "/waste/" + objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

export const getWasteList = ({
  businessId,
  subcategory,
  subcategory_description,
  category,
  subcategoryId,
  setObjects = function () {
    return;
  },
  setTotalObj = function () {
    return;
  },
  setSystemBoundaryWaste = function () {
    return;
  },
  setTotalWaste = function () {
    return;
  },
  setBuyerOptions = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/waste",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotalObj(response.data.total_obj);
      setSystemBoundaryWaste(response.data.total_obj.systemboundary_category);
      setTotalWaste(response.data.total_waste);

      const uniqueBuyers = new Set(
        response.data.data.map((data) => data.buyer).filter(Boolean)
      );
      const buyerOptions = Array.from(uniqueBuyers).map((buyer) => ({
        value: buyer,
        name: buyer,
      }));
      setBuyerOptions(buyerOptions);

      setObjects(
        response.data.data
          .filter(
            (data) =>
              data.category === category &&
              data.subcategory === subcategory &&
              data.subcategory_description === subcategory_description &&
              (subcategoryId === null || data.subcategory_obj === subcategoryId)
          )
          .map((data) => {
            data.type_surplus_material = objectifyForDropdown(
              data.type_surplus_material
            );
            data.type_current_disposal = objectifyForDropdown(
              data.type_current_disposal
            );
            data.type_waste_water = objectifyForDropdown(data.type_waste_water);
            data.type_surplus_energy = objectifyForDropdown(
              data.type_surplus_energy
            );
            data.is_reused = data.is_reused ? "Yes" : "No";
            return data;
          })
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getWasteListTreatment = ({
  businessId,
  subcategory,
  subcategory_description,
  category,
  subcategoryId,
  setObjects = function () {
    return;
  },
  setTotalObj = function () {
    return;
  },
  setSystemBoundaryWaste = function () {
    return;
  },
  setTotalWaste = function () {
    return;
  },
  setBuyerOptions = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/waste",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotalObj(response.data.total_obj);
      setSystemBoundaryWaste(response.data.total_obj.systemboundary_category);
      setTotalWaste(response.data.total_waste);

      const uniqueBuyers = new Set(
        response.data.data.map((data) => data.buyer).filter(Boolean)
      );
      const buyerOptions = Array.from(uniqueBuyers).map((buyer) => ({
        value: buyer,
        name: buyer,
      }));
      setBuyerOptions(buyerOptions);

      setObjects(
        response.data.data
          .filter(
            (data) =>
              data.category === category &&
              data.subcategory === "Treatment of ingoing delivery-packaging"
          )
          .map((data) => {
            data.type_surplus_material = objectifyForDropdown(
              data.type_surplus_material
            );
            data.type_current_disposal = objectifyForDropdown(
              data.type_current_disposal
            );
            data.nickname = objectifyForDropdown(data.nickname);
            data.type_waste_water = objectifyForDropdown(data.type_waste_water);
            data.type_surplus_energy = objectifyForDropdown(
              data.type_surplus_energy
            );
            data.is_reused = data.is_reused ? "Yes" : "No";
            return data;
          })
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getWasteWater = ({
  businessId,
  category,
  setObjects = function () {
    return;
  },
  setTotalObj = function () {
    return;
  },
  setSystemBoundaryWaste = function () {
    return;
  },
  setTotalWaste = function () {
    return;
  },
  setBuyerOptions = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/waste",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotalObj(response.data.total_obj);
      setSystemBoundaryWaste(response.data.total_obj.systemboundary_category);
      setTotalWaste(response.data.total_waste);

      const uniqueBuyers = new Set(
        response.data.data.map((data) => data.buyer).filter(Boolean)
      );
      const buyerOptions = Array.from(uniqueBuyers).map((buyer) => ({
        value: buyer,
        name: buyer,
      }));
      setBuyerOptions(buyerOptions);

      setObjects(
        response.data.data
          .filter((data) => data.category === category)
          .map((data) => {
            data.type_surplus_material = objectifyForDropdown(
              data.type_surplus_material
            );
            data.type_current_disposal = objectifyForDropdown(
              data.type_current_disposal
            );
            data.type_waste_water = objectifyForDropdown(data.type_waste_water);
            data.type_surplus_energy = objectifyForDropdown(
              data.type_surplus_energy
            );
            data.is_reused = data.is_reused ? "Yes" : "No";
            return data;
          })
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getWasteEnergy = ({
  businessId,
  category,
  setObjects = function () {
    return;
  },
  setTotalObj = function () {
    return;
  },
  setSystemBoundaryWaste = function () {
    return;
  },
  setTotalWaste = function () {
    return;
  },
  setBuyerOptions = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/waste",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotalObj(response.data.total_obj);
      setSystemBoundaryWaste(response.data.total_obj.systemboundary_category);
      setTotalWaste(response.data.total_waste);

      const uniqueBuyers = new Set(
        response.data.data.map((data) => data.buyer).filter(Boolean)
      );
      const buyerOptions = Array.from(uniqueBuyers).map((buyer) => ({
        value: buyer,
        name: buyer,
      }));
      setBuyerOptions(buyerOptions);

      setObjects(
        response.data.data
          .filter((data) => data.category === category)
          .map((data) => {
            data.type_surplus_material = objectifyForDropdown(
              data.type_surplus_material
            );
            data.type_current_disposal = objectifyForDropdown(
              data.type_current_disposal
            );
            data.type_waste_water = objectifyForDropdown(data.type_waste_water);
            data.type_surplus_energy = objectifyForDropdown(
              data.type_surplus_energy
            );
            data.is_reused = data.is_reused ? "Yes" : "No";
            return data;
          })
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateWaste = ({
  businessId,
  objectId,
  type_surplus_material,
  type_current_disposal,
  is_reused,
  category,
  subcategory,
  subcategory_description,
  amount,
  price_invoice,
  current_disposal,
  product,
  avoided_emission,
  buyer,
  share,
  surplus_materials_sold,
  invoice_date,
  invoice_number,
  type_waste_water,
  total_waste_water,
  water_sold,
  type_surplus_energy,
  typedb_surplus_energy,
  wasted_surplus_energy,
  sold_surplus_energy,
  wasted_energy,
  money_earned,
  wasted_emission,
  subcategoryId,
  nickname,
  objects,
  setObjects = function () {
    return;
  },
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  var data = JSON.stringify({
    subcategory_obj: subcategoryId,
    type_surplus_material: type_surplus_material,
    type_current_disposal: type_current_disposal,
    is_reused: is_reused,
    category: category,
    subcategory: subcategory,
    subcategory_description: subcategory_description,
    amount: amount,
    price_invoice: price_invoice || null,
    current_disposal: current_disposal || 0,
    avoided_emission: avoided_emission,
    product: product,
    surplus_materials_sold: surplus_materials_sold || null,
    buyer: buyer || null,
    share: share || null,
    invoice_date: invoice_date || null,
    invoice_number: invoice_number || null,
    type_waste_water: type_waste_water,
    total_waste_water: total_waste_water,
    water_sold: water_sold || null,
    type_surplus_energy: type_surplus_energy,
    typedb_surplus_energy: typedb_surplus_energy,
    wasted_surplus_energy: wasted_surplus_energy,
    sold_surplus_energy: sold_surplus_energy || null,
    wasted_energy: wasted_energy,
    money_earned: money_earned,
    wasted_emission: wasted_emission,
    nickname: nickname,
    year: year,
  });

  var config = {
    method: "put",
    url: baseUrl + "/api/business/" + businessId + "/waste/" + objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setObjects(
        objects.map((supply) => {
          if (response.data.data.id === supply.id) {
            response.data.data.type_surplus_material = objectifyForDropdown(
              response.data.data.type_surplus_material
            );
            response.data.data.type_current_disposal = objectifyForDropdown(
              response.data.data.type_current_disposal
            );
            response.data.data.type_waste_water = objectifyForDropdown(
              response.data.data.type_waste_water
            );
            response.data.data.type_surplus_energy = objectifyForDropdown(
              response.data.data.type_surplus_energy
            );
            if (subcategory === "Treatment of ingoing delivery-packaging") {
              response.data.data.nickname = objectifyForDropdown(
                response.data.data.nickname
              );
            }
            response.data.data.is_reused = response.data.data.is_reused
              ? "Yes"
              : "No";
            return response.data.data;
          }
          return supply;
        })
      );
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");

      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultUpdateErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      setErrorMessage(error.response.data);
    });
};

export const getWaste = ({ businessId, objectId, objects, setObjects }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/waste/" + objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(
        objects.map((supply) => {
          const gotValue = response.data.data;

          if (gotValue.id === supply.id) {
            gotValue.id_dropdown_product = gotValue.product.id;
            gotValue.product = gotValue.product.name;
            gotValue.type_surplus_material = objectifyForDropdown(
              gotValue.type_surplus_material
            );
            gotValue.type_current_disposal = objectifyForDropdown(
              gotValue.type_current_disposal
            );
            gotValue.type_waste_water = objectifyForDropdown(
              gotValue.type_waste_water
            );
            gotValue.type_surplus_energy = objectifyForDropdown(
              gotValue.type_surplus_energy
            );

            gotValue.is_reused = gotValue.is_reused ? "Yes" : "No";
            return gotValue;
          }
          return supply;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
      // setLoading(false)
      // Swal.fire({
      //   title: errorTranslate(),
      //   icon: 'error',
      //   text: error,
      //   confirmButtonColor: '#a9c1b4',
      //   // width: 600,
      //   // padding: '3em',
      //   color: '#476355',
      //   background: '#f1f8ef',
      // })
    });
};

export const postShareWaste = (businessId, share, setShareChecked) => {
  var config = {
    method: "post",
    url: baseUrl + "/api/business/" + businessId + "/waste/share",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      share,
    },
  };

  axios(config)
    .then(function (response) {
      setShareChecked(share);
    })
    .catch(function (error) {});
};

export const getSharesWaste = (setMarkerData, searchItem) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/shared-waste?item=" + searchItem,
  };

  axios(config)
    .then(function (response) {
      setMarkerData(response.data.data);
    })
    .catch(function (error) {});
};

export const getWasteSubcategory = ({
  businessId,
  setCustomSubcategory = function () {
    return;
  },
  setSubcategoryNames = function () {
    return;
  },
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/waste-sub",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setCustomSubcategory(response.data);
      const subNames = response.data.map((item) => {
        return item.name;
      });
      setSubcategoryNames(subNames);
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
    });
};

export const updateWasteSubcategory = ({
  businessId,
  objectId,
  objects,
  subcategory,
  subcategory_description,
  setObjects = function () {
    return;
  },
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    name: subcategory,
    subcategory_description: subcategory_description,
  });

  var config = {
    method: "put",
    url: baseUrl + "/api/business/" + businessId + "/waste-sub/" + objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setErrorMessage();
      setObjects(response.data);
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");

      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultUpdateErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

export const createWasteSubcategory = ({
  businessId,
  objectId,
  objects,
  subcategory,
  subcategory_description,
  setObjects = function () {
    return;
  },
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
  triggerInvalidate = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    name: subcategory,
    subcategory_description: subcategory_description,
  });

  var config = {
    method: "post",
    url: baseUrl + "/api/business/" + businessId + "/waste-sub",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");
  const key = "add-new-surplus-resource-subcategory";

  axios(config)
    .then(function (response) {
      setErrorMessage();
      setObjects(response.data);
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (key) triggerInvalidate(key);
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");

      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultUpdateErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

export const deleteWasteSubcategory = ({
  businessId,
  objectId,
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
  triggerInvalidate = function () {
    return;
  },
}) => {
  var config = {
    method: "delete",
    url: baseUrl + "/api/business/" + businessId + "/waste-sub/" + objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  if (loading) setLoading("load");
  const key = "delete-surplus-resource-subcategory";

  axios(config)
    .then(function (response) {
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      if (key) triggerInvalidate(key);
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: error,
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};
